import ResetPasswordForm from './ResetPasswordForm';
import {actions, connect, selectors} from '../../../stores'

const mapStateToProps = state => ({
  resetPasswordByEmail: selectors.auth.selectResetPasswordByEmail(state),
});
const mapDispatchToProps = dispatch => ({
  confirmForgotPassword: payload => dispatch(actions.auth.confirmForgotPassword(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordForm);
